// #/services/registry/getServiceActionKeys.ts

import getService from './getService';
import getActionKeysFromService from './openApi/utils/getActionKeysFromService';

export async function getServiceActionKeys(
  serviceKey: string,
): Promise<string[]> {
  try {
    // console.info('getServiceActionKeys(', serviceKey, ')');

    const service = await getService(serviceKey);

    if (service == null) {
      return [];
    }

    return getActionKeysFromService(service);
  } catch (error: any) {
    console.error(
      `Error fetching actions for service ${serviceKey}: ${error.message}`,
    );
    // throw new Error(`Error fetching actions for service ${serviceKey}: ${error.message}`);
    return [];
  }
}

export default getServiceActionKeys;
